$(document).ready(function(){
  // setTimeout(function(){
  //   $('.product-recommendations .product-loop').flickity({
  //     // options
  //     cellAlign: 'left',
  //     wrapAround: true,
  //     contain: true
  //   });    
  // },1000)
  
  var navhash = window.location.href.split('#');
  var navid = navhash[1];
  
  if(navid != undefined){
      $('html, body').stop().animate({
            'behavior': 'smooth',
          'scrollTop': $('#'+navid).offset().top - $('.header-group').height()
      }, 1000, 'swing', function() {
    });    
  }
  
  $('.navigation__menu .dropdown__menuitem a').on('click', function(e) {
    
  	var target = this.hash;
  	var $target = $(target);
  	var get_id = $(this).attr('href');
  	$('html, body').stop().animate({
          'behavior': 'smooth',
        'scrollTop': $target.offset().top - $('.header-group').height()
    }, 1000, 'swing', function() {
    });
  });

  $('.mobile-menu .c-accordion__panel a').on('click', function(e) {
      
  	var target = this.hash;
  	var $target = $(target);
  	var get_id = $(this).attr('href');
    
    if( target){
      $('body').removeClass('slideout-left--open');
      $('.slideout__drawer-left').removeClass('slideout--active');
      $('body').removeAttr('style');
    }
    
  	$('html, body').stop().animate({
          'behavior': 'smooth',
        'scrollTop': $target.offset().top - $('.header-group').height()
    }, 1000, 'swing', function() {
    });
  });

  
 if($('.timer-section').length > 0){
  (function () {
    const second = 1000,
          minute = second * 60,
          hour = minute * 60,
          day = hour * 24;
  
    //I'm adding this section so I don't have to keep updating this pen every year :-)
    //remove this if you don't need it
    let today = new Date(),
        dd = String(today.getDate()).padStart(2, "0"),
        mm = String(today.getMonth() + 1).padStart(2, "0"),
        yyyy = today.getFullYear(),
        nextYear = yyyy + 1,
        dayMonth = "07/01/",
        birthday = dayMonth + yyyy;
    
    today = mm + "/" + dd + "/" + yyyy;
    if (today > birthday) {
      birthday = dayMonth + nextYear;
    }
    //end
    
    const countDown = new Date(birthday).getTime(),
        x = setInterval(function() {    
  
          const now = new Date().getTime(),
                distance = countDown - now;
  
          document.getElementById("days").innerText = Math.floor(distance / (day)),
            document.getElementById("hours").innerText = Math.floor((distance % (day)) / (hour)),
            document.getElementById("minutes").innerText = Math.floor((distance % (hour)) / (minute)),
            document.getElementById("seconds").innerText = Math.floor((distance % (minute)) / second);
  
          //do something later when date is reached
          if (distance < 0) {
            document.getElementById("headline").innerText = "It's my birthday!";
            document.getElementById("countdown_timer").style.display = "none";
            document.getElementById("content").style.display = "block";
            clearInterval(x);
          }
          //seconds
        }, 0)
    }());
  }
  
});

/* Gift subscription widget ATC button update */ 
(() => {
  const wrapper = document.querySelector('.recharge-gifting-widget');
  if (!wrapper) return;

  // Required fields inside gift widget
  const requiredSelectors = [
    '#rc_gift_recipient_first_name',
    '#rc_gift_recipient_last_name',
    '#rc_gift_recipient_email',
    '#rc_gift_notification_scheduled_at'
  ];

  let requiredFields = [];
  let widgetForm = null;

  function initFields() {
    requiredFields = requiredSelectors
      .map(s => wrapper.querySelector(s))
      .filter(Boolean);
    
    widgetForm = document.querySelector('form[id^="rc_gifting_"]');
  }

  // Email format check
  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  // Find correct product form (must contain Recharge hidden field)
  function getProductForm() {
    const forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (const f of forms) {
      if (f.querySelector('input[name="properties[__rc_gift_sender_name]"]')) {
        return f;
      }
    }
    return null;
  }

  // Check if gift fields are valid
  function isGiftFormValid() {
    if (!requiredFields.length) {
      initFields();
    }
    
    if (!requiredFields.length) return false;
    
    const allFilled = requiredFields.every(f => f && f.value && f.value.trim().length > 0);
    const emailField = wrapper.querySelector('#rc_gift_recipient_email');
    const validEmail = emailField ? isValidEmail(emailField.value.trim()) : false;
    const widgetValid = widgetForm ? widgetForm.checkValidity() : true;
    
    return allFilled && validEmail && widgetValid;
  }

  function getSubmitButton() {
    const form = getProductForm();
    if (!form) return null;
    return form.querySelector('.js-ajax-submit, button[type="submit"], input[type="submit"], button');
  }

  function updateButtonState() {
    const button = getSubmitButton();
    if (!button) return;

    const giftValid = isGiftFormValid();
    
    // Check if button is disabled due to sold out (by checking the text/value)
    const buttonText = (button.value || button.textContent || '').toLowerCase();
    const isSoldOut = buttonText.includes('sold out') || 
                     buttonText.includes('unavailable') || 
                     buttonText.includes('out of stock');
    
    // If gift form is invalid, always disable
    // If gift form is valid but product is sold out, keep disabled
    if (!giftValid) {
      button.disabled = true;
    } else if (isSoldOut) {
      button.disabled = true;
    } else {
      button.disabled = false;
    }
  }

  // Attach listeners to required fields
  function attachListeners() {
    initFields();
    
    requiredFields.forEach(field => {
      field.addEventListener('input', updateButtonState);
      field.addEventListener('change', updateButtonState);
      field.addEventListener('blur', updateButtonState);
    });
    
    updateButtonState();
  }

  // Override the button disabled property setter to intercept changes
  function interceptButtonDisable() {
    const button = getSubmitButton();
    if (!button || button.__giftValidationIntercepted) return;
    
    // Mark as intercepted to avoid multiple interceptions
    button.__giftValidationIntercepted = true;
    
    const originalDescriptor = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'disabled') ||
                              Object.getOwnPropertyDescriptor(HTMLButtonElement.prototype, 'disabled');
    
    if (!originalDescriptor) return;
    
    Object.defineProperty(button, 'disabled', {
      get() {
        return originalDescriptor.get.call(this);
      },
      set(value) {
        // If trying to enable (value = false), check gift validation first
        if (value === false && !isGiftFormValid()) {
          originalDescriptor.set.call(this, true);
        } else {
          originalDescriptor.set.call(this, value);
        }
      },
      configurable: true
    });
  }

  // Listen for variant change events
  function setupVariantListener() {
    if (typeof events !== 'undefined' && events.on) {
      events.on("variantchange", function(variant) {
        // Use multiple timeouts to ensure we override theme.js
        setTimeout(updateButtonState, 0);
        setTimeout(updateButtonState, 10);
        setTimeout(updateButtonState, 50);
        setTimeout(updateButtonState, 100);
      });
    }
    
    // Also try with window.events
    if (typeof window.events !== 'undefined' && window.events.on) {
      window.events.on("variantchange", function(variant) {
        setTimeout(updateButtonState, 0);
        setTimeout(updateButtonState, 10);
        setTimeout(updateButtonState, 50);
        setTimeout(updateButtonState, 100);
      });
    }
  }

  // Watch for button attribute changes
  function watchButton() {
    const button = getSubmitButton();
    if (!button) return;
    
    const buttonObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'disabled') {
          // Re-validate immediately
          setTimeout(updateButtonState, 0);
        }
      });
    });
    
    buttonObserver.observe(button, { 
      attributes: true, 
      attributeFilter: ['disabled'] 
    });
  }

  // Initialize everything
  function init() {
    const form = getProductForm();
    if (form) {
      attachListeners();
      interceptButtonDisable();
      watchButton();
      setupVariantListener();
      updateButtonState();
    }
  }

  // Observe DOM because widget fields load async
  const observer = new MutationObserver(() => {
    const form = getProductForm();
    if (form) {
      init();
      observer.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // In case the form is already available
  if (getProductForm()) {
    // Wait a bit to ensure eventemitter3 and theme.js are loaded
    setTimeout(init, 100);
  }
})();